//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { workXuqiuList, workTypeTree, workDemandDelete } from "@/api/gxInfo";
import YuyueDriverDialog from "../components/YuyueDriverDialog";
export default {
  data() {
    return {
      filterForm: {
        ownerName: "",
        checkedWorkType: [],
        checkedRegion: [],
        // auditStatusStr:'20,40,50,60,70'
      },
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [], // 表格数据
      workTypeList:[],
      props:{
        label:'name',
        value:'code',
      },
      regionProps: {
        lazy: true,
        lazyLoad: this.lazyLoad,
        expandTrigger: "hover",
        value: "i",
        label: "n",
        checkStrictly: true
      },
      loading:false
    };
  },
  components:{
    YuyueDriverDialog
  },
  watch: {
    ["filterForm.checkedRegion"]:{
      handler(val) {
        (!val) && (this.filterForm.checkedRegion=[]);
      }
    }
  },
  created() {
    this.handleFilter();
    this.getWorkTypes();
  },
  methods: {
    /* @description: 异步加载地区数据
     * @Author: likk
     * @Date: 2023-08-02 14:19:56
     * @param {*} level
     * @param {*} value
     * @param {*} resolve
     * @return {*}
     */
     async lazyLoad({ level, value }, resolve) {
      let dataSource = [];
      if (level === 0) {
        dataSource = await this.getChildRegion(1);
      } else {
        dataSource = await this.getChildRegion(value);
      }
      resolve(
        dataSource.map((item) => ({
          ...item,
          leaf: level >= 2,
        }))
      );
    },
     /**
     * @description: 根据父id查询省市县乡村子地区
     * @Author: likk
     * @Date: 2023-08-02 15:35:57
     * @return {*}
     */
     async getChildRegion(pid) {
      const { data } = await this.$http.common.getChildRegion({ pid });
      return data || [];
    },
    handleRegionChange(refName){
      this.$refs[refName].dropDownVisible = false
    },
    /**
     * @Author: likk
     * @description: 获取作业类型数据
     * @param {*}
     * @return {*}
     */   
    async getWorkTypes(){
      const { data: {result} } = await workTypeTree() || [];
      this.workTypeList = result;
    },
    
    /**
     * @Author: likk
     * @description: 获取作业需求列表
     * @param {*}
     * @return {*}
     */ 
     async getList(){
      try {
        this.loading = true;
        let { checkedWorkType, checkedRegion, ...params } = this.filterForm;
        let { data:{content,recordTotal} } = await workXuqiuList({
          ...params,
          workType:checkedWorkType[checkedWorkType.length-1],
          workProvinceId: checkedRegion[0] || "",
          workCityId: checkedRegion[1] || "",
          workCountyId: checkedRegion[2] || "",
          currentPage:this.pagination.pageNum,
          pageSize:this.pagination.pageSize
        });
        this.tableData = content;
        this.pagination.total = recordTotal;
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },   
    /**
     * @Author: likk
     * @description: 查询
     * @param {Number} page 页码
     * @return {*}
     */  
    handleFilter(page=1){
      this.pagination.pageNum = page;
      this.getList();
    }, 
    /**
      * @Author: likk
      * @description: 查看
      * @param {*}
      * @return {*}
    */    
    handleDetail(id){
      this.$router.push({
        path:'/gx-query/xuqiu/detail',
        query:{id}
      })
    },
    /**
      * @Author: likk
      * @description: 查看
      * @param {*}
      * @return {*}
    */ 
    handleAudit(id){
      this.$router.push({
        path:'/gx-query/xuqiu/audit',
        query: {id}
      })
    },
    handleEdit(id){
      this.$router.push({
        path:'/gx-query/xuqiu/edit',
        query: {id}
      })
    },
    handleDelete(id){
      this.$confirm("确认要删除该数据吗？", "", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(() => {
        workDemandDelete(id).then( () => {
          this.$message({ type: 'success',  message: '删除成功' });
          this.handleFilter();
        });
      })
    },
    /**
    * @Author: likk
    * @description: 预约机手
    * @param {*}
    * @return {*}
    */ 
    handleYuyue(id){
      this.$refs.yuyueDriver.init(id);
    },
   /**
    * @Author: likk
    * @description:预约成功 
    * @param {*}
    * @return {*}
    */    
    yuyueSuccess(){
      this.handleFilter();
    }
  },
};
